import { apiCall } from "../service/api-service";

export const getLeadsListApi = async (params) => {
  return apiCall("GET", `web/lead${params}`);
};

export const createLeadsApi = async (data) => {
  return apiCall("POST", "web/lead", data);
};

export const getLeadDetailsApi = async (id) => {
  const response = await apiCall("GET", `web/lead/edit/${id}`);
  return response.data;
};

export const UpdateLeadsApi = async (data, id) => {
  return apiCall("PUT", `web/lead/${id}`, data);
};

export const getLeadDataApi = async (id) => {
  const response = await apiCall("GET", `web/lead/view/${id}`);
  return response.data;
};

export const updateWebScrapingApi = async (data, id) => {
  return apiCall("POST", `update_web_scraping/${id}`, data);
};

export const getWebScrapingApi = async (bodyData) => {
  return apiCall("POST", "web_scraping", bodyData);
};

export const getLeadsOwnerApi = async (id) => {
  return apiCall("GET", `web/get_lead_owner?id=${id == null ? 0 : id}`);
};

export const getLeadStatusApi = async () => {
  const response = await apiCall("GET", `lead/leadstatus_autosuggestion`);
  return response.data;
};
export const getNotesApi = async (params, id) => {
  const response = await apiCall("GET", `web/lead/notes/${id}${params}`);
  return response.data;
};
export const addNoteApi = async (noteData, id) => {
  const response = await apiCall("PUT", `web/lead/notes/${id}`, noteData);
  return response.data;
};

export const getAttachmentsApi = async (params, id) => {
  const response = await apiCall("GET", `web/lead/attachment/${id}${params}`);
  return response.data;
};

export const addAttachmentApi = async (payload, id) => {
  const apiPayload = { attachment: payload };
  const response = await apiCall(
    "PUT",
    `web/lead/attachment/${id}`,
    apiPayload,
  );
  return response.data;
};

export const getActivityApi = async (params, id) => {
  const response = await apiCall("GET", `web/lead/activities/${id}${params}`);
  return response.data;
};

export const getHistoryApi = async (params, id) => {
  const response = await apiCall("GET", `web/lead/history/${id}${params}`);
  return response.data;
};

export const updateWebsiteInfoApi = async (payload, id) => {
  const response = await apiCall(
    "PUT",
    `web/update_lead_website/${id}`,
    payload,
  );
  return response.data;
};

export const updateLeadStatusApi = async (payload, id) => {
  const response = await apiCall(
    "PUT",
    `web/update_lead_status/${id}`,
    payload,
  );
  return response.data;
};

export const checkLeadConversionApi = async (id) => {
  const response = await apiCall(
    "GET",
    `web/check_lead_conversion/${id}`
  );
  return response?.data || response;
};

export const getLoadLinkedInProfilesApi = async (id) => {
  return apiCall("GET", `get_linkedin_details/${id}`);
};

export const getLinkedInProfilesApi = async (id) => {
  return apiCall("GET", `lead/linkedin/${id}`);
};

export const updateLinkedInProfilesApi = async (payload, id) => {
  return apiCall("PUT", `lead/linkedin/${id}`, payload);
};
export const getLeadContactsApi = async (id) => {
  return apiCall("GET", `web/lead/contacts/${id}`);
};

export const getLeadAiSummaryApi = async (id, payload = {}) => {
  return apiCall("POST", `web/lead/ai_summary/${id}`, payload);
};

export const askLeadChatApi = async (payload) => {
  return apiCall("POST", "web/lead/ai_chat", payload);
};

export const getAiProvidersApi = async () => {
  return apiCall("GET", "web/lead/ai_providers");
};
